import { EntitlementSlugEnum } from '@electricjs/core_entity-client';

import { TagTypes, apiSlice } from '@/redux/slices/apiSlice';
import {
  HelpfulLinkArgs,
  HelpfulLinkPayload,
  HelpfulLinksDto,
} from '@/types/helpfulLinks';

export const helpfulLinkSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getHelpfulLinks: builder.query<HelpfulLinkPayload[], string>({
      query: (organizationId: string) => ({
        url: `/v1/organizations/${organizationId}/helpful_links`,
        meta: { entitlements: [EntitlementSlugEnum.HelpfulLinks] },
      }),
      providesTags: [TagTypes.HelpfulLinks],
      transformResponse: (helpfulLinks: HelpfulLinksDto[]) => {
        return (
          helpfulLinks?.map(link => ({
            linkId: link.link_id,
            title: link.title,
            linkUrl: link.link_url,
            description: link.description,
          })) ?? []
        );
      },
    }),
    createHelpfulLink: builder.mutation<void, HelpfulLinkPayload>({
      query: ({
        organizationId,
        linkUrl,
        title,
        description,
      }: HelpfulLinkPayload) => ({
        url: `/v1/organizations/${organizationId}/helpful_links`,
        method: 'POST',
        body: {
          link_url: linkUrl,
          title,
          description,
        },
        meta: { entitlements: [EntitlementSlugEnum.HelpfulLinks] },
      }),
      invalidatesTags: [TagTypes.HelpfulLinks],
    }),
    deleteHelpfulLink: builder.mutation<void, HelpfulLinkArgs>({
      query: ({ organizationId, linkId }: HelpfulLinkArgs) => ({
        url: `/v1/organizations/${organizationId}/helpful_links/${linkId}`,
        method: 'DELETE',
        meta: { entitlements: [EntitlementSlugEnum.HelpfulLinks] },
      }),
      invalidatesTags: [TagTypes.HelpfulLinks],
    }),
    updateHelpfulLink: builder.mutation<void, HelpfulLinkPayload>({
      query: ({
        organizationId,
        linkId,
        linkUrl,
        title,
        description,
      }: HelpfulLinkPayload) => ({
        url: `/v1/organizations/${organizationId}/helpful_links/${linkId}`,
        method: 'PUT',
        body: {
          link_url: linkUrl,
          title,
          description,
        },
        meta: { entitlements: [EntitlementSlugEnum.HelpfulLinks] },
      }),
      invalidatesTags: [TagTypes.HelpfulLinks],
    }),
  }),
});

export const {
  useGetHelpfulLinksQuery,
  useCreateHelpfulLinkMutation,
  useDeleteHelpfulLinkMutation,
  useUpdateHelpfulLinkMutation,
} = helpfulLinkSlice;
